// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';

/**
 * 系统管理
 */
// 用户管理
import user from '@/views/system/user';
// 菜单管理
import Module from '@/views/system/Module';
// 角色管理
import Role from '@/views/system/Role';
// 公司管理
import Dept from '@/views/system/Dept';
// 系统环境变量
import Variable from '@/views/system/Variable';
// 权限管理
import Permission from '@/views/system/Permission';


// 数据榜单
import crmList from '@/views/crm/list';
// 我的线索
import crmClue from '@/views/crm/clue';
// 我的客户
import crmCustomer from '@/views/crm/customer';
// 我的业绩
import crmScore from '@/views/crm/score';
// 财务中心
import crmFinance from '@/views/crm/finance';
// 我的项目
import crmProject from '@/views/crm/project';
// 文档下载
import crmDoc from '@/views/crm/doc';
// 个人中心
import crmPersonal from '@/views/crm/personal';
// 系统设置
import crmSystem from '@/views/crm/system';
// 消息通知
import crmAdvice from '@/views/crm/advice';

// 启用路由
Vue.use(Router);

// 导出路由 
export default new Router({
    routes: [{
        path: '/',
        name: '',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/login',
        name: '登录',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    },
     {
        path: '/index',
        name: '首页',
        component: index,
        iconCls: 'el-icon-tickets',
        children: [{
            path: '/system/user',
            name: '用户管理',
            component: user,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Module',
            name: '菜单管理',
            component: Module,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Role',
            name: '角色管理',
            component: Role,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Dept',
            name: '公司管理',
            component: Dept,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Variable',
            name: '系统环境变量',
            component: Variable,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Permission',
            name: '权限管理',
            component: Permission,
            meta: {
                requireAuth: true
            }
        }, {
          path: '/crm/list',
          name: '数据榜单',
          component: crmList,
          iconCls: 'el-icon-tickets',
          children: [],
          hidden: false,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/crm/clue',
          name: '我的线索',
          component: crmClue,
          iconCls: 'el-icon-tickets',
          children: [],
          hidden: false,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/crm/customer',
          name: '我的客户',
          component: crmCustomer,
          iconCls: 'el-icon-tickets',
          children: [],
          hidden: false,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/crm/score',
          name: '我的业绩',
          component: crmScore,
          iconCls: 'el-icon-tickets',
          children: [],
          hidden: false,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/crm/finance',
          name: '财务中心',
          component: crmFinance,
          iconCls: 'el-icon-tickets',
          children: [],
          hidden: false,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/crm/project',
          name: '我的项目',
          component: crmProject,
          iconCls: 'el-icon-tickets',
          children: [],
          hidden: false,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/crm/doc',
          name: '文档下载',
          component: crmDoc,
          iconCls: 'el-icon-tickets',
          children: [],
          hidden: false,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/crm/personal',
          name: '个人中心',
          component: crmPersonal,
          iconCls: 'el-icon-tickets',
          children: [],
          hidden: false,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/crm/system',
          name: '系统设置',
          component: crmSystem,
          iconCls: 'el-icon-tickets',
          children: [],
          hidden: false,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/crm/advice',
          name: '消息通知',
          component: crmAdvice,
          iconCls: 'el-icon-tickets',
          children: [],
          hidden: false,
          meta: {
            requireAuth: true
          }
        }
      ]
    }
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js